/**
 * Convert a PNG benefit logo URL to its SVG equivalent
 * @param url - The PNG logo URL
 * @returns The SVG logo URL
 */
export function convertBenefitLogoToSvg(url: string): string {
    return url.replace(/\.png$/, '.svg');
}

export function isSessionStartedAfterRewardLaunch(
    sessionStartDate: string,
    featureLaunchDate?: string
): boolean {
    if (!sessionStartDate || !featureLaunchDate) {
        return false;
    }

    const sessionDate = new Date(sessionStartDate);
    const launchDate = new Date(featureLaunchDate);
    return sessionDate >= launchDate;
}
